import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import AdminUserRegistrationForm from '../auth/AdminUserRegistrationForm';

function AdminUserManagement() {
  return (
    <Box>
      <Typography variant="h3" component="h2" gutterBottom sx={{ mb: 3 }}>
        User Management
      </Typography>
      <Paper sx={{ p: 3, mb: 4, boxShadow: 1 }}>
        <AdminUserRegistrationForm />
      </Paper>
      <Paper sx={{ p: 3, boxShadow: 1 }}>
        <Typography variant="h4" component="h3" gutterBottom>
          View/Edit Existing Users
        </Typography>
        <Typography variant="body1">
          (Coming Soon: Table to list, edit, or delete users)
        </Typography>
      </Paper>
    </Box>
  );
}

export default AdminUserManagement;